/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-21 11:01:09
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-26 12:54:56
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductReview/ProductReviewDetail/slice/common.ts
 */
// const _key = '+++';

// const openCollapseIdGenerator = ({ type, uuid }) => {
//   return `${type}${_key}${uuid}`;
// };

// const openCollapseIdProcessor = (id) => {
//   const [type, uuid] = id.splice(_key);
//   return { type, uuid };
// };

import {
  sortSales,
  //sortLocales,
  //sortReviews,
} from 'src/pages/ProductReview/common';
import _ from 'lodash';
import { EnumReviewType } from '../../common';
import {
  assData,
  reduxUpdatedStatusControl,
  formatLocaleSalesChannel,
  //getProduct,
} from 'src/tools/helper';

//现有逻辑 salesChannel 不同locale相同uuid，只是locale字段不同

const _subLocaleDefault = () => {
  return { top: false, publish: false };
};

const convertSalesChannelIntoChannelFormat = (channels) => {
  //转换salesChannel 格式到locales：【】形式
  const r = sortSales(
    formatLocaleSalesChannel({ channels, localeSupply: _subLocaleDefault() }),
  );
  // const mappedByUuid = channels.reduce((pre, channel) => {
  //   const {
  //     uuid,
  //     name,
  //     channelType,
  //     locale,
  //     timezone,
  //     timezoneGmt,
  //     isPrimary,
  //     status,
  //   } = channel;
  //   if (pre[uuid]) {
  //     (pre[uuid].locales || []).push(_subLocaleDefault({ locale, isPrimary }));
  //     sortLocales(pre[uuid].locales);
  //   } else {
  //     pre[uuid] = {
  //       name,
  //       uuid,
  //       channelType,
  //       timezone,
  //       timezoneGmt,
  //       status,
  //       locales: [_subLocaleDefault({ locale, isPrimary })],
  //     };
  //   }
  //   return pre;
  // }, {});

  // const r = sortSales(Object.values(mappedByUuid));

  return r;
};

const mapProductReviewSalesChannelsFromServerToRedux = ({
  channels,
  productReviewSalesChannels = [],
}) => {
  const _channels = _.cloneDeep(channels || []);
  const mappedChannels = _channels.reduce((pre, now) => {
    const { uuid } = now;
    return { ...pre, [uuid]: now };
  }, {});
  productReviewSalesChannels.map((i) => {
    const { salesChannelUuid, top, publish, locale } = i;
    const target = mappedChannels[salesChannelUuid].locales.find(
      (i) => i.locale == locale,
    );
    if (target) {
      target.top = top;
      target.publish = publish;
    }
  });
  const r = sortSales(Object.values(mappedChannels));
  return r;
};

const convertSingleReviewFromServerToRedux = ({ review, channels }) => {
  const {
    createdDate,
    order,
    content,
    fromSalesChannel,
    customerName,
    staffUuid,
    medias,
    replies,
    productReviewSalesChannels,
    uuid,
    status,
    title,
    rating,
    ...rest
  } = review || {};
  const _productReviewSalesChannels: any =
    mapProductReviewSalesChannelsFromServerToRedux({
      channels,
      productReviewSalesChannels,
    });
  return {
    rating,
    title,
    createdDate,
    order,
    content,
    fromSalesChannel,
    customerName,
    staffUuid,
    medias,
    replies,
    productReviewSalesChannels: _productReviewSalesChannels,
    uuid,
    status,
    ...rest,
  };
};

const convertInitDataFromServerToRedux = ({ state, data }) => {
  const {
    salesChannels, //aggregation,
    statusGroups,
    product,
  } = data;
  const _salesChannels = convertSalesChannelIntoChannelFormat(salesChannels);
  // const { averageRating } = aggregation;

  const allReviews =
    (statusGroups.find((i) => i.status === EnumReviewType.All) || {}).reviews ||
    [];
  const _mappedReviews = allReviews.map((i) => {
    return convertSingleReviewFromServerToRedux({
      channels: _salesChannels,
      review: i,
    });
  });

  const reviews = _mappedReviews.reduce((pre, now) => {
    const { uuid } = now;
    return { ...pre, [uuid]: now };
  }, {});

  const orders = Object.keys(reviews);
  orders.sort();
  assData(state, {
    salesChannels: _salesChannels,
    orders,
    reviews,
    product,
    ...reduxUpdatedStatusControl,
  });
};

const updateSingleReview = ({ state, review, channels }) => {
  const _review = convertSingleReviewFromServerToRedux({
    review,
    channels,
  });

  const { uuid } = _review;
  const currentUuids = Object.keys(state.reviews);
  const preExist = currentUuids.includes(uuid);

  state.reviews[uuid] = _review;
  if (!preExist) {
    state.orders.push(uuid);
  }
};

const convertProductReviewFromReduxToServer = (review) => {
  const { productReviewSalesChannels: _productReviewSalesChannels, ...rest } =
    review;
  const productReviewSalesChannels = _productReviewSalesChannels.reduce(
    (pre, channel) => {
      const { locales, uuid } = channel;
      const currentChannel = locales.map((i) => {
        const { top, publish, locale } = i;
        return { top, publish, locale, salesChannelUuid: uuid };
      });
      return [...pre, ...currentChannel];
    },
    [],
  );
  return { productReviewSalesChannels, ...rest };
};

export {
  // openCollapseIdGenerator, openCollapseIdProcessor
  convertSalesChannelIntoChannelFormat,
  mapProductReviewSalesChannelsFromServerToRedux,
  convertSingleReviewFromServerToRedux,
  convertInitDataFromServerToRedux,
  convertProductReviewFromReduxToServer,
  updateSingleReview,
};
